import { CollectionService } from './index';

const ReportService = CollectionService('reports');

export default ReportService;
